export default function AccordingNoteIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#EBE1F9" />
      <path
        d="M17.3346 11V8.53337C17.3346 7.41327 17.3346 6.85322 17.1166 6.42539C16.9249 6.04907 16.6189 5.74311 16.2426 5.55136C15.8148 5.33337 15.2547 5.33337 14.1346 5.33337H9.86797C8.74786 5.33337 8.18781 5.33337 7.75999 5.55136C7.38366 5.74311 7.0777 6.04907 6.88596 6.42539C6.66797 6.85322 6.66797 7.41327 6.66797 8.53337V15.4667C6.66797 16.5868 6.66797 17.1469 6.88596 17.5747C7.0777 17.951 7.38366 18.257 7.75999 18.4487C8.18781 18.6667 8.74786 18.6667 9.86797 18.6667H12.0013M13.3346 11.3334H9.33464M10.668 14H9.33464M14.668 8.66671H9.33464M16.0013 18V14M14.0013 16H18.0013"
        stroke="#7F56D9"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
